import React, { useCallback, useState, useEffect, useRef } from "react";
import "./App.css";
import { AppRoutes } from "./containers/routes/routes";
import { Security } from "@okta/okta-react";
import { User } from "./context/user/User";
import { Layout } from "./layout/layout";
import { Language } from "./context/language/language";
import { Sponsor } from "./context/Sponsor";
import { OktaAuth } from "@okta/okta-auth-js";
import { fetchSitesData } from "services/authentication-service";
import { Login } from "components/login/login";
import { PassPoliciesProvider } from "context/PassPolicy";

export const App: React.FC = () => {
  const oktaAuth = useRef<OktaAuth | null>(null);
  const [networkStatus, setNetworkStatus] = useState<
    "NotStarted" | "InProgress" | "Success" | "Failed"
  >("NotStarted");

  useEffect(() => {
    fetchSitesData()
      .then((data) => {
        if(oktaAuth?.current == null){
        oktaAuth.current = new OktaAuth({
          clientId: "nike.nde.passplayclient",
          issuer: data?.oktaAuth,
          redirectUri: `${process.env.PUBLIC_URL}callback`,
          postLogoutRedirectUri: `${window.location.origin}/login`,
          responseType: ["token", "id_token"],
          pkce: false,
          tokenManager: {
            storageKey: "nike.nde.passplayclient",
            storage: "sessionStorage",
          },
        });
        setNetworkStatus("Success");
      }
      })
      .catch((error) => {
        setNetworkStatus("Failed");
      });
  }, []);

  const restoreOriginalUri = useCallback(
    (oktaAuth: OktaAuth, originalUri: string) => {
      if (originalUri) window.location.replace(originalUri);
      else window.location.replace("/");
    },
    []
  );

  return oktaAuth.current ? (
    <div className="body-bg">
      <Language>
        <Security
          oktaAuth={oktaAuth.current}
          restoreOriginalUri={restoreOriginalUri}
        >
          <User>
            <Sponsor>
              <PassPoliciesProvider>
                <Layout>
                  <AppRoutes />
                </Layout>
              </PassPoliciesProvider>
            </Sponsor>
          </User>
        </Security>
      </Language>
    </div>
  ) : (
    <Language>
      <Login isNetworkError={networkStatus == "Failed"} />
    </Language>
  );
};

export default App;
